import * as React from 'react';
import Svg, {Path, Rect} from 'react-native-svg';
interface IProps {
  color?: string;
  width?: number;
  height?: number;
}
const ExclusiveRewards = ({
  width = 51,
  height = 50,
  color = '#006DFF',
}: IProps) => (
  <Svg width={width} height={height} fill="none">
    <Rect
      width={50}
      height={50}
      x={0.75}
      fill={color}
      fillOpacity={0.15}
      rx={8}
    />
    <Path
      fill={color}
      fillRule="evenodd"
      d="M20.465 23.414v.001ZM24.806 13.393h2.455c.237 0 .421-.205.396-.44l-.19-1.765a.398.398 0 0 0-.396-.355h-2.076a.398.398 0 0 0-.395.355l-.19 1.765a.398.398 0 0 0 .396.44ZM30.102 38.356a.397.397 0 0 1-.422-.052l-.39-.319-.454.214a.398.398 0 0 1-.529-.534l.635-1.315 1.5-12.114-.294-1.43a.399.399 0 0 1 .643-.39l.334.275v-1.575c0-5.074-3.845-6.08-3.845-7.236h-2.475c0 .98-2.765 1.853-3.605 5.192l.003.001.404-.353a.398.398 0 0 1 .427-.062l.489.222.404-.353a.398.398 0 0 1 .427-.063l.489.222.404-.353a.398.398 0 0 1 .427-.063l.488.222.403-.352a.396.396 0 0 1 .254-.1H25.837a.398.398 0 0 1 .382.48l-.263 1.495c.503 1.614.997 3.948 1.36 6.428.365 2.48.563 4.857.546 6.548l.687 1.367a.398.398 0 0 1-.521.542l-.489-.222-.404.353a.398.398 0 0 1-.427.062l-.489-.222-.404.353a.398.398 0 0 1-.427.063l-.488-.222-.405.353a.398.398 0 0 1-.427.063l-.488-.222-.404.353a.398.398 0 0 1-.427.063l-.489-.222-.404.353a.398.398 0 0 1-.427.063l-.468-.213v.858a2.653 2.653 0 0 0 2.652 2.652h4.86c.849 0 1.604-.399 2.09-1.02l-.006-.004-.455.214Z"
      clipRule="evenodd"
    />
    <Path
      fill={color}
      fillRule="evenodd"
      d="m36.869 23.51-.683.32-.583-.477-.683.32-.583-.477-.683.32-.584-.477-.682.32-.584-.477-.682.32-.584-.476.308 1.495-1.517 12.243-.663 1.375.683-.32.583.477.683-.32.584.476.682-.32.584.477.682-.32.584.477.682-.32.584.477-.308-1.495 1.517-12.244.663-1.374ZM20.407 31.549a4.09 4.09 0 0 1-4.043-3.497 4.065 4.065 0 0 1 .766-3.036 4.064 4.064 0 0 1 3.287-1.65 4.089 4.089 0 0 1 4.042 3.497 4.064 4.064 0 0 1-.765 3.036 4.064 4.064 0 0 1-3.287 1.65Zm1.784 3.435.723.328.597-.522.722.328.598-.521.722.328.598-.522.722.328.597-.522.723.328-.73-1.454c.024-1.614-.157-3.974-.54-6.582-.383-2.608-.888-4.92-1.376-6.459l.282-1.603-.598.522-.722-.328-.598.522-.722-.328-.597.522-.723-.328-.597.522-.722-.328-.598.521-.722-.328-.598.522-.722-.328-.597.522-.723-.328-.597.522-.722-.328-.598.522-.722-.328-.598.521-.722-.328.73 1.454c-.024 1.614.157 3.974.54 6.582.383 2.608.888 4.92 1.376 6.46l-.282 1.602.598-.522.722.328.597-.522.723.328.597-.521.722.328.598-.522.722.328.598-.522.722.328.597-.522Z"
      clipRule="evenodd"
    />
    <Path
      fill={color}
      fillRule="evenodd"
      d="M16.759 27.993a3.693 3.693 0 1 0 7.307-1.073 3.693 3.693 0 0 0-7.307 1.073Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default ExclusiveRewards;
